// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderHoc_container__3oJLV","loader":"LoaderHoc_loader__g6AVe"};